import React from 'react';
import RoleButton from 'components/RoleButton';
import {
    ADMIN,
    MANAGER,
    ASSISTANT_MANAGER
} from 'components/RoleGate/constants';
import { WorksheetType } from 'services/worksheet/types';
import { VIEW_WORKSHEET_MODAL } from 'components/WorksheetForm/constants';
import { useSelector } from 'react-redux';
import { AppState } from 'services/types';
import { selectEventExistsInCurrentWeek } from './selectors';

export interface Props {
    worksheetType: WorksheetType;
}

export default function ViewWorksheetButton(
    props: Props
): React.ReactElement | null {
    const eventExistsInCurrentWeek = useSelector((state: AppState) =>
        selectEventExistsInCurrentWeek(state, props)
    );

    if (eventExistsInCurrentWeek) {
        return (
            <RoleButton
                requiredRoles={[ADMIN, MANAGER, ASSISTANT_MANAGER]}
                params={{ [VIEW_WORKSHEET_MODAL]: true }}
                buttonProps={{ secondary: true, style: { margin: 0 } }}
                ignoreSeason
            >
                View Worksheet
            </RoleButton>
        );
    }

    return null;
}
